// extracted by mini-css-extract-plugin
export default {"faqBox":"faq-box_faqBox__wyyrM","faqBox__img":"faq-box_faqBox__img__xJ-lL","faqBox__subtitle":"faq-box_faqBox__subtitle__cRsD8"};